import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthGuard } from './_helpers/auth.guard';
import { NoAuthGuard } from './_helpers/no-auth.guard';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { AdminFeeComponent } from './admin-fee/admin-fee.component';
import { VendorAllEarningComponent } from './vendor-all-earning/vendor-all-earning.component';
import { VendorsRevenueComponent } from './vendors-revenue/vendors-revenue.component';

const routes: Routes = [

  { path: '', component: LoginComponent, canActivate: [NoAuthGuard] },

  { path: 'login', component: LoginComponent, canActivate: [NoAuthGuard] },

  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [NoAuthGuard] },

  { path: 'privacy-policy', component: PrivacyPolicyComponent },

  { path: 'admin-fee', component: AdminFeeComponent },

  { path: 'vendors-revenue', component: VendorsRevenueComponent },

  { path: 'vendor-all-earning', component: VendorAllEarningComponent },

  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [NoAuthGuard] },

  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },

  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },

  { path: 'bookings', loadChildren: () => import('./booking/booking.module').then(m => m.BookingModule), canActivate: [AuthGuard] },

  { path: 'manage', loadChildren: () => import('./management/management.module').then(m => m.ManagementModule), canActivate: [AuthGuard] },

  { path: 'customers', loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule), canActivate: [AuthGuard] },

  { path: 'complains', loadChildren: () => import('./complaints/complaints.module').then(m => m.ComplaintsModule), canActivate: [AuthGuard] },

  { path: 'combo-booking', loadChildren: () => import('./combo-booking/combo-booking.module').then(m => m.ComboBookingModule), canActivate: [AuthGuard] },

  { path: 'refund-management', loadChildren: () => import('./refund-management/refund-management.module').then(m => m.RefundManagementModule), canActivate: [AuthGuard] },

  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule), canActivate: [AuthGuard] },

  { path: 'coupon-management', loadChildren: () => import('./coupon-management/coupon-management.module').then(m => m.CouponsManagementModule), canActivate: [AuthGuard] },

  { path: 'vendors', loadChildren: () => import('./vendors/vendors.module').then(m => m.VendorsModule), canActivate: [AuthGuard] },

  { path: 'leads', loadChildren: () => import('./leads/leads.module').then(m => m.LeadsModule), canActivate: [AuthGuard] },

  { path: 'manage/locations', loadChildren: () => import('./location/location.module').then(m => m.LocationModule), canActivate: [AuthGuard] },

  { path: 'chat', loadChildren: () => import('./chat/chat.module').then(m => m.ChatModule), canActivate: [AuthGuard] },

  { path: 'partners', loadChildren: () => import('./partners/partners.module').then(m => m.PartnersModule), canActivate: [AuthGuard] },

  {path: 'app-management', loadChildren: () => import('./app-management/app-management.module').then(m => m.AppManagementModule), canActivate: [AuthGuard]},

  { path: '**', redirectTo: '/login' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
